import {useSelector} from "react-redux";
import {Avatar, Button, Card, Checkbox, Form, List, Modal, notification, Row, Select, Space, Switch} from "antd";
import React, {Fragment, useEffect, useState} from "react";
import {DeleteOutlined, EditOutlined, PlusOutlined} from "@ant-design/icons";
import ApiService from "../../services/ApiService";
import IntlMessage from "../util-components/IntlMessage";
import {isMobile} from "react-device-detect";


export default function AccessAttrAvatars({id, accessAttr, onChange, accessType, withRoles,accessExtra}) {
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const org = useSelector(_state => _state.auth.org)
    const access = useSelector(_state => _state.auth.access)

    const onEdit = async (_data) => {

        setLoading(true)

        let payload={type: accessType, accessAttr: _data.accessAttr}
        if(accessExtra){
            payload.extra=accessExtra
        }

        var res = await ApiService.post("/access/changeAttr/" + id, payload)

        setLoading(false)

        if (res.success) {
            notification.success({
                message: (<IntlMessage id="success.add"/>)
            })

            setVisible(false)
            if (onChange) {
                onChange(_data)
            }
        } else {
            notification.error({
                message: (<IntlMessage id="error.add"/>)
            })
        }
    }

    let avatarList = []

    for (let at of accessAttr) {
        let bgColor = "#000"
        let shortName = at?.prenom.slice(0, 3).toUpperCase()

        const _access = org.accessList.find(i => i.id === at.id)
        const _accessAttr = accessAttr?.find(i => i.id === at.id) || {}

        if (_access && _access.shortName) {
            shortName = _access.shortName
        }
        if (_access && _access.color) {
            bgColor = _access.color
        }

        avatarList.push({shortName: shortName, bgColor: bgColor, owner: _accessAttr.owner || false})
    }

    avatarList.sort((a, b) => {
        if (a.owner === b.owner) {
            return 0
        }
        return a.owner < b.owner ? 1 : -1
    })

    const allowEdit = access.allowEditAttr || access.type === "ADMIN" || false

    return (
        <Fragment>
            <div style={{cursor: allowEdit ? "pointer" : "auto"}} onClick={!allowEdit ? null : () => setVisible(true)}>

                {avatarList.length > 0 && (
                    <Avatar.Group size={avatarList.length > 1 || isMobile ? "small" : "default"} maxCount={2}>
                        {avatarList.map(i => {
                            return (
                                <Avatar style={{backgroundColor: i.bgColor, color: "#FFF"}}>{i.shortName}</Avatar>
                            )
                        })}
                    </Avatar.Group>
                )}

                {avatarList.length === 0 && allowEdit && (
                    <Avatar size={isMobile ? "small" : "default"}
                            style={{backgroundColor: "rgb(0, 151, 178)", color: "#FFF"}}><PlusOutlined/></Avatar>
                )}

                {avatarList.length === 0 && !allowEdit && (
                    "-"
                )}
            </div>


            <Modal centered width={"100%"} title={"Modifier l'attribution"} open={visible} destroyOnClose closable
                   footer={null} onCancel={() => setVisible(false)}>

                <Form initialValues={{accessAttr: accessAttr}} onFinish={(_data) => {
                    console.log(_data)
                    onEdit(_data)
                }}>

                    <Form.Item name={"accessAttr"}>
                        <CustomAccessField accessList={org.accessList || []} withRoles={withRoles}/>
                    </Form.Item>


                    <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Valider
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </Fragment>
    )
}


function CustomAccessField({accessList, value, onChange, withRoles}) {
    const [roles, setRoles] = useState([])

    const getRoles = async () => {
        var res = await ApiService.get("/access/attr/roles")
        console.log(res)
        setRoles(res.items)
    }

    useEffect(() => {
        if (withRoles) {
            getRoles()
        }
    }, []);


    if (!value || !Array.isArray(value)) {
        onChange([])
        return false
    }

    const addItem = (id) => {
        const _access = accessList.find(i => i.id === id)
        if (!_access) {
            return false
        }
        onChange([...value, {id: id, prenom: _access.prenom, nom: _access.nom}])
    }

    const deleteItem = (id) => {
        onChange(value.filter(i => i.id !== id))
    }

    const setOwner = (id) => {
        onChange(value.map(i => {
            i.owner = i.id === id
            return i
        }))
    }

    const editRoles = (id, roles) => {
        onChange(value.map(i => {
            if (i.id === id) {
                i.roles = roles
            }
            return i
        }))
    }


    if (value.length === 1 && !value[0].owner) {
        setOwner(value[0].id)
        return false
    }

    return (
        <Fragment>
            <Card title={"Utilisateurs"} type={"inner"} extra={(
                <Select placeholder={"Ajouter un utilisateur"} value={null} onChange={(v) => addItem(v)}>
                    {accessList.filter(i => value.every(j => j.id !== i.id)).map(al => {

                        let bgColor = al.color || "#000"
                        let shortName = al.shortName || al?.prenom.slice(0, 3).toUpperCase()

                        return (
                            <Select.Option value={al.id}>
                                <Space>
                                    <Avatar size={"small"}
                                            style={{backgroundColor: bgColor, color: "#FFF"}}>{shortName}</Avatar>
                                    <span>{al.prenom} {al.nom}</span>
                                </Space>
                            </Select.Option>
                        )
                    })}
                </Select>
            )}>


                <List
                    itemLayout={isMobile ? "vertical" : "horizontal"}
                    dataSource={value}
                    renderItem={(item, index) => {
                        const al = accessList.find(i => i.id === item.id)
                        console.log(item, al)

                        if (!al) {
                            return null
                        }

                        let bgColor = al.color || "#000"
                        let shortName = al.shortName || al?.prenom.slice(0, 3).toUpperCase()

                        let title = al.prenom + " " + al.nom

                        if (item.auto) {
                            title += " (auto)"
                        }

                        return (
                            <List.Item
                                actions={[(
                                    <Button size={"small"} danger icon={<DeleteOutlined/>}
                                            onClick={() => deleteItem(item.id)}/>
                                )]}
                            >
                                <List.Item.Meta
                                    avatar={isMobile ? null : <Avatar size={"large"} style={{
                                        backgroundColor: bgColor,
                                        color: "#FFF"
                                    }}>{shortName}</Avatar>}
                                    title={title}
                                    description={(
                                        <Space direction={isMobile ? "vertical" : "horizontal"} style={{marginTop: 10}}>
                                            <Checkbox disabled={item.owner} checked={item.owner}
                                                      onChange={() => setOwner(item.id)}>Propriétaire</Checkbox>

                                            {withRoles && (
                                                <Select style={{minWidth: 300}} mode="tags"
                                                        onChange={(v) => editRoles(item.id, v)} value={item.roles || []}
                                                        placeholder={"Roles"}>
                                                    {roles.map(i => (
                                                        <Select.Option value={i}>{i}</Select.Option>
                                                    ))}
                                                </Select>
                                            )}
                                        </Space>
                                    )}
                                />
                            </List.Item>
                        )
                    }}
                />

            </Card>

        </Fragment>
    )
}
